import { render, staticRenderFns } from "./Docs.vue?vue&type=template&id=ddb27c28&scoped=true"
import script from "./Docs.js?vue&type=script&lang=js&external"
export * from "./Docs.js?vue&type=script&lang=js&external"
import style0 from "./Docs.scss?vue&type=style&index=0&id=ddb27c28&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ddb27c28",
  null
  
)

export default component.exports